
























import Vue from "vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import store from "store";

export default Vue.extend({
  components: { ButtonDefault },
  methods: {
    async submitTwitterAuth() {
      const response = await fetch(`${process.env.VUE_APP_TWITTER_AUTH_API_ENDPOINT}/?cb=${location.origin}`);
      const json = await response.json();
      console.log({ json });

      store.set("twitter-token-secret", json.oauthTokenSecret);
      location.href = json.authenticateUrl;
    },
    backToSignIn() {
      this.$router.push({ name: "signIn" });
    },
  },
});
